import { capitalize } from '@ember/string';

export function formattedToReadable(value: string): string {
  return capitalize(value.toLowerCase().replaceAll('_', ' '));
}
